import { SettingsForm, type FieldSpec } from "../SettingsForm.js";

const FIELDS: FieldSpec[] = [
  { kind: "group", label: "Provider" },
  { kind: "checkbox", key: "aiActive", label: "KI aktiv", help: "Globaler Schalter für den AI Operating Layer." },
  {
    kind: "select", key: "provider", label: "Provider",
    help: "Heute regelbasiert (ai-core / konzept-core). Ein LLM-Provider ist noch nicht angebunden.",
    options: [
      { value: "rule_based", label: "Regelbasiert (aktuell)" },
      { value: "anthropic", label: "Anthropic" },
      { value: "openai", label: "OpenAI" },
      { value: "azure_openai", label: "Azure OpenAI" },
      { value: "mistral", label: "Mistral" },
    ],
  },
  { kind: "text", key: "model", label: "Modell", placeholder: "z. B. claude-3-5-sonnet" },
  { kind: "number", key: "temperature", label: "Temperatur", min: 0, max: 2, step: 0.1 },
  { kind: "number", key: "maxTokens", label: "Max Tokens", min: 256, max: 200000, step: 256 },

  { kind: "group", label: "Engines" },
  { kind: "checkbox", key: "engineEnergyExpert", label: "Energy Expert Core" },
  { kind: "checkbox", key: "engineKonzept", label: "Konzept Engine" },
  { kind: "checkbox", key: "engineRoofDesigner", label: "Roof Designer AI" },
  { kind: "checkbox", key: "engineFoerder", label: "Förder-Engine" },
  { kind: "checkbox", key: "engineNormen", label: "Normen-Engine" },
  { kind: "checkbox", key: "engineWirtschaftlichkeit", label: "Wirtschaftlichkeits-Engine" },
];

const MASTERPROMPT_NOTE = (
  <div className="skeleton-note" style={{ background: "#eef2ff", borderColor: "#6366f1", color: "#3730a3" }}>
    <span>🔒</span>
    <span>
      <strong>Master-Prompts sind sichtbar, aber nicht editierbar.</strong> Sie sind im Code versioniert
      (ai-core / konzept-core). Nur Administratoren dürfen Versionen wechseln — und auch das erfolgt
      kontrolliert über Releases, nicht über dieses Formular. <strong>Die KI darf niemals freigeben</strong>
      {" "}(canApprove ist strukturell false).
    </span>
  </div>
);

export function KiSection() {
  return (
    <SettingsForm
      category="ai"
      title="KI & Expertensystem"
      intro="Verwaltung des EnergyOS AI Operating Layer. Provider-/Modellkonfiguration ist vorausschauend — die heutigen Engines arbeiten regelbasiert."
      fields={FIELDS}
      footer={MASTERPROMPT_NOTE}
    />
  );
}
